export const environment = {
	production: true,
	kenticoRoot: 'https://symposium.hillsdale.edu/data',
	kenticoToken: '',
	defaultDonationUrl: 'https://secured.hillsdale.edu/hillsdale/support-online-courses/'
};
